import React from 'react';
import classNames from './RecordingPanelView.module.css';
import { observer } from 'mobx-react-lite';
import { SelectSingleSearchTermControl } from './SelectSingleSearchTermControl';
import { SingleOriginFilterView } from './SingleOriginFilterView';
import { RecordingPanelState } from './RecordingPanelState';


export const ChronologicalEventsSubpanelControlsView = observer(({
	recordingPanelState
}: { recordingPanelState: RecordingPanelState }) => {
	const { searchUiState } = recordingPanelState;
	return (
		<div className={classNames.ControlHeader}>
				<SelectSingleSearchTermControl {...{ searchUiState }} />
				<SingleOriginFilterView label={"Page"} singleOriginFilterState={recordingPanelState.sourcePageUrlFilterState} />
				<SingleOriginFilterView label={"Destination"} singleOriginFilterState={searchUiState.destinationUrlFilterState} />
		</div>
	);
});
